/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import api from '../../../services/api';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    paddingEmissao: {
        padding: theme.spacing(1)
    }
}))

export default function FormItensNfe(props) {

    const classes = useStyles();

    const { codigoNfe } = props;

    const [open, setOpen] = React.useState(false);

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const iframePdf = useRef(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    useEffect(() => {

        async function carregarPdf() {
            if (open) {
                await buscarPdf();
            }

        }

        carregarPdf()

    }, [open])


    async function buscarPdf() {
        let dadosEnvio = {
            DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
            DBUSERNAME: localStorage.getItem("DBUSERNAME"),
            DBESQUEMA: localStorage.getItem("DBESQUEMA"),
            DBPID: localStorage.getItem("DBPID"),
            MANDNUMBER: localStorage.getItem("MANDNUMBER"),
            PROCNAME: "GETPDFDESTINATARIOBYDOC",
            EMPNUMBER: localStorage.getItem("EMPNUMBER"),
            PCNRNF: codigoNfe,
            PCCDTPDOCFIS: '65'
        };

        const resposta = await api.post('execute', dadosEnvio);
        iframePdf.current.href = `data:application/pdf;base64,${resposta.data.PPDF.replaceAll('\n', '').replaceAll('\r', '')}`;
        iframePdf.current.download = `${resposta.data.PFILENAME}.pdf`;
        iframePdf.current.click();
        setOpen(false);

    }


    const handleOpen = (e) => {
        e.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function cancelar() {
        setOpen(false);
    }

    return (
        <>
            <Grid item xs={6} className={classes.paddingEmissao}>
                <Button
                    type="button"
                    color="primary"
                    variant="contained"
                    onClick={handleOpen}
                    fullWidth
                >
                    Imprimir
                </Button>
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullScreen
            >
                <DialogTitle id="scroll-dialog-title">DANFE</DialogTitle>
                <DialogContent dividers='true'>
                    <DialogContentText
                        id="scroll-dialog-description"

                        tabIndex={-1}
                    >
                        <a href="pdf" download="chart.pdf" ref={iframePdf} >
                            download
                        </a>

                    </DialogContentText>


                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={cancelar}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}